/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
  Divider,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useHistory } from "react-router-dom";
import { loginState, configState } from "../lib/State"; // 로그인 (1)
import axios from "axios";
import Swal from "sweetalert2";
import { useState, forwardRef, useEffect, useRef } from "react";
import RegisterFormRecommand from "./RegisterFormRecommand";
import pr from "../lib/pr";
import RegisterFormAddr from "./RegisterFormAddr";
import RegisterFormPhone from "./RegisterFormPhone";
import get_cid from "../lib/get_cid";

function RegisterForm(props) {
  const { goNextPage, goPreviousPage } = props;
  const cid = get_cid();

  const recommendRef = useRef();

  // 데이타폼
  const [data, setData] = useState({
    cid: cid,
    pass1: "",
    pass2: "",
    mname: "",
    birth: "",
    sex: "",
    height: "",
    weight: "",
  });

  // 추가데이타
  const [birth, setBirth] = useState(""); // 생일
  const [rname, setRname] = useState(""); // 추천인 이름
  const [rphone, setRphone] = useState(""); // 추천인 연락처
  const [addr1, setAddr1] = useState(""); // 기본주소
  const [addr2, setAddr2] = useState(""); // 상세주소
  const [auth, setAuth] = useState(""); // 인증번호
  const [phone, setPhone] = useState("");

  const onInputChange = (e) => {
    setData((state) => ({ ...state, [e.target.name]: e.target.value }));
  };

  const onChangeBirth = (e) => {
    // 생일 형식지정
    let tmp = e.target.value;
    tmp = tmp.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
    setBirth(tmp);
    setData((state) => ({ ...state, birth: tmp }));
  };

  const onJoinClick = async () => {
    let result = await axios.post(configState.api + "/gympass/join", {
      ...data,
      rname: rname,
      rphone: rphone,
      addr1: addr1,
      addr2: addr2,
      auth: auth,
      phone: phone,
    });
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      reg_complete();
    }
  };

  const reg_complete = () => {
    Swal.fire({ title: "등록되었습니다.", showCloseButton: true }).then(
      (result) => {
        window.location.href = `/?cid=${cid}`;
      }
    );
  };

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
    >
      <Box
        sx={{
          width: "85%",
        }}
      >
        <div className="text-xs opacity-50 mt-10">(필수입력사항)</div>
        <Grid container width="100%">
          <TextField
            autoComplete="off"
            name="mname"
            label="이름"
            size="small"
            variant="standard"
            style={{
              width: "100%",
            }}
            onChange={onInputChange}
          ></TextField>
        </Grid>

        <RegisterFormPhone
          setAuthParent={setAuth}
          setPhoneParent={setPhone}
        ></RegisterFormPhone>

        <Grid container width="100%" sx={{ marginTop: "25px" }}>
          <TextField
            autoComplete="off"
            name="pass1"
            label="비밀번호"
            size="small"
            type="password"
            variant="standard"
            style={{
              width: "100%",
            }}
            onChange={onInputChange}
          ></TextField>
        </Grid>
        <Grid container width="100%" sx={{ mt: 0.5 }}>
          <TextField
            autoComplete="off"
            name="pass2"
            label="비밀번호 확인"
            size="small"
            type="password"
            variant="standard"
            style={{
              width: "100%",
            }}
            onChange={onInputChange}
          ></TextField>
        </Grid>
        <Box sx={{ fontSize: 14, mt: 0.5 }}>
          비밀번호는 4~12자리 영문과 숫자로 입력하세요.
        </Box>

        {/* 추천인등록 */}
        <RegisterFormRecommand setRphone={setRphone} setRname={setRname} />

        {/* 주소입력 */}

        <Divider sx={{ mt: 5 }} />

        <div className="text-xs opacity-50 mt-10">(선택입력사항)</div>
        <RegisterFormAddr set1={setAddr1} set2={setAddr2}></RegisterFormAddr>
        <Grid
          container
          width="100%"
          justifyContent="space-between"
          alignItems="center"
          marginTop="10px"
        >
          <TextField
            autoComplete="off"
            name="birth"
            label="생년월일 (예:20210101)"
            size="small"
            type="text"
            variant="standard"
            style={{
              width: "50%",
            }}
            onChange={(e) => onChangeBirth(e)}
            value={birth}
          ></TextField>
          <Box
            direction="column"
            width="43%"
            sx={{ mt: 2, paddingLeft: "10px" }}
          >
            <Box
              style={
                {
                  // marginBottom: "5px",
                }
              }
            >
              성별
            </Box>
            <RadioGroup
              row
              name="sex"
              defaultValue=""
              style={{
                width: "100%",
                marginLeft: "7px",
              }}
              onChange={onInputChange}
            >
              <FormControlLabel
                value="남"
                control={
                  <Radio
                    sx={{
                      padding: 0,
                      "& .MuiSvgIcon-root": { fontSize: "20px" },
                    }}
                  />
                }
                label="남자"
              />
              <FormControlLabel
                value="여"
                control={
                  <Radio
                    sx={{
                      padding: 0,
                      marginLeft: "5px",
                      "& .MuiSvgIcon-root": { fontSize: "20px" },
                    }}
                  />
                }
                label="여자"
              />{" "}
            </RadioGroup>
          </Box>
        </Grid>

        <Grid container width="100%">
          <TextField
            autoComplete="off"
            name="height"
            label="키"
            size="small"
            variant="standard"
            style={{
              width: "100%",
            }}
            onChange={onInputChange}
            InputProps={{
              endAdornment: <InputAdornment position="end">cm</InputAdornment>,
            }}
          ></TextField>
        </Grid>
        <Grid container width="100%" marginBottom="10px" sx={{ mt: 0.5 }}>
          <TextField
            autoComplete="off"
            name="weight"
            label="체중"
            size="small"
            variant="standard"
            style={{
              width: "100%",
            }}
            onChange={onInputChange}
            InputProps={{
              endAdornment: <InputAdornment position="end">kg</InputAdornment>,
            }}
          ></TextField>
        </Grid>
        <Box sx={{ fontSize: 14, width: "100%", marginBottom: "25px" }}>
          키와 체중은 심박계 이용 시 칼로리 계산을 위해 사용됩니다.
          <br></br>
          추후 정보수정에서 언제든지 변경 가능합니다.
        </Box>
      </Box>
      <Box height="120px"></Box>
      <Grid
        container
        display="flex"
        justifyContent="center"
        paddingTop="20px"
        paddingBottom="25px"
        sx={{
          position: "fixed",
          bottom: 0,
          zIndex: 10,
          background: "white",
        }}
      >
        <Button
          variant="contained"
          sx={{
            width: "40%",
            margin: "5px",
            background: "#0092a2",
            ":hover": { background: "#0092a2" },
          }}
          onClick={onJoinClick}
        >
          가입하기
        </Button>
        <Button
          variant="outlined"
          sx={{
            width: "40%",
            margin: "5px",
            border: "1px solid gray",
            color: "gray",
          }}
          onClick={goPreviousPage}
        >
          취소
        </Button>
      </Grid>
    </Grid>
  );
}

export default RegisterForm;
